module.exports = __webpack_public_path__ + "static/img/es_main_img.da0bc16.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/es_main_img.png
// module id = JZlt
// module chunks = 1